module.exports = __webpack_public_path__ + "static/media/summary_02.297bea7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/news/images/summary_02.png
// module id = 1203
// module chunks = 0